import saveToClipboard from './saveToClipboard';

export default function initEvents() {
  document.querySelectorAll('.js-link-open-chat')
    .forEach((link) => link.addEventListener('click',
      (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('open-webim-chat'));
      }));

  saveToClipboard();
}
